export const FRESHA_URL = "https://www.fresha.com/p/mwezi-mjoli-4489930?share=true&pId=1469337";
export const STORE_URL = "https://locticiancarlocs.co.za/shop";
export const CONTACT_EMAIL = "info@locticiancarlocs.co.za";
export const CONTACT_PHONE = "+27 78 858 3255";
export const WHATSAPP_URL = "https://wa.me/27788583255";
export const INSTAGRAM_URL = "https://instagram.com/loctician_carlocs";

export const SOCIALS = [
  { name: "Instagram", icon: "Instagram", url: "https://instagram.com/loctician_carlocs" },
  { name: "Facebook", icon: "Facebook", url: "https://facebook.com/loctician_carlocs" },
  { name: "TikTok", icon: "Music2", url: "https://tiktok.com/@loctician_carlocs" },
  { name: "YouTube", icon: "Youtube", url: "https://youtube.com/@loctician_carlocs" },
];

export const ISSUE_LABELS = {
  hydration: "Hydration",
  buildup: "Buildup / Residue",
  irritation: "Irritation / Redness",
  density: "Density / Thinning",
  dandruff: "Dandruff / Flaking",
  general: "General",
};
